import { handleError as T } from "../js/request-DH6Y2P3c.js";
import { arrayToMap as w } from "../utils/utils.js";
import { useQuery as f } from "@tanstack/react-query";
import { useMemo as h, useRef as P, useEffect as k } from "react";
const l = {}, A = (t, s, r) => {
  const { getLabel: e, getValue: a, sort: n = !0 } = s || {};
  return h(() => {
    if (!e || !a || !t)
      return [];
    const u = t.map((o) => ({
      label: e(o),
      value: a(o)
    }));
    return n && u.sort((o, y) => o.label.toLowerCase().localeCompare(y.label.toLowerCase())), r != null && r.includeNoneOption && (s != null && s.noneOption) && u.unshift(s.noneOption), u;
  }, [t, e, a, n, r, s == null ? void 0 : s.noneOption]);
}, E = (t, s) => {
  const { getKey: r, getValue: e } = s ?? {};
  return h(() => !r || !t ? {} : w(t, r, e), [t, r, e]);
}, F = (t) => t && t.isFetched && !t.isError, H = (t, s, r, e) => {
  if (e != null && e.aborted)
    throw t;
  const a = s ?? r.errorMessage;
  return T(t, {
    displayToast: !!a,
    toastMessage: a
  }), !1;
}, i = (t, s, r, e, a, n) => {
  const { disabled: u, onSuccess: o, errorMessage: y } = a, c = P(), p = [...t, r], b = f({
    queryKey: p,
    queryFn: (d) => (c.current = d.signal, s(r, d.signal).then((m) => {
      var M;
      if ((M = c == null ? void 0 : c.current) != null && M.aborted)
        throw new Error("Fetch Aborted");
      return m;
    })),
    throwOnError: (d) => H(d, y, n, c == null ? void 0 : c.current),
    enabled: !u && !e,
    refetchOnMount: a == null ? void 0 : a.refetchOnMount,
    retry: (d, m) => (m == null ? void 0 : m.status) === 404 ? !1 : d < 4,
    refetchOnWindowFocus: !1
  });
  return k(() => {
    F(b) && (o == null || o(b.data));
  }, [b, o]), b;
}, B = (t, s, r) => (e, a = l) => {
  const n = Array.isArray(e) ? e : e ?? 0, u = Array.isArray(n) ? n.some((o) => !o) : !e;
  return i(t, s, n, u, a, r);
}, K = (t, s, r) => (e, a = l) => {
  const n = h(() => r.disable ? r.disable(e) : !1, [e]);
  return i(
    t,
    s,
    e,
    n,
    a,
    r
  );
}, L = (t, s, r) => (e = l, a = l) => {
  const n = i(
    t,
    (c, p) => s(p),
    void 0,
    !1,
    e,
    r
  ), u = Array.isArray(n.data) ? n.data : void 0, o = E(u, r.parseToMap), y = A(
    u,
    r.parseToOptions,
    a
  );
  return { ...n, map: o, options: y };
}, O = (t, s, r) => (e = l, a = l, n = l) => {
  const u = h(() => r.disable ? r.disable(e) : !1, [e]), o = i(
    t,
    s,
    e,
    u,
    a,
    r
  ), y = E(o.data, r.parseToMap), c = A(
    o.data,
    r.parseToOptions,
    n
  );
  return { ...o, map: y, options: c };
}, _ = {
  getByIdHook: B,
  searchParamsHook: O,
  regularHook: K,
  noParamsHook: L
};
export {
  _ as default
};
//# sourceMappingURL=HookBuilder.js.map
